import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import { MaterialModule } from 'src/app/app.materials';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-volatility',
  templateUrl: './volatility.component.html',
  standalone: true,
  imports: [MaterialModule, FormsModule, CommonModule]
})
export class VolatilityComponent implements OnInit, OnChanges {
  @Input() index: any = {};
  @Input() benchmark: any = {};

  volatilityList = [];
  drawdownList = [];
  sharpeList = [];

  constructor() { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.index) {
      this.index = changes.index.currentValue;
      this.updateLists();
    }
    if (changes.benchmark) {
      this.benchmark = changes.benchmark.currentValue;
      this.updateLists();
    }
  }

  updateLists() {
    this.volatilityList = [];
    this.drawdownList = [];
    this.sharpeList = [];

    this.checkModel(this.index);
    this.checkModel(this.benchmark);
  }

  checkModel(model) {
    if (model && model.volatility && model.volatility.length) {
      model.volatility[0].index = model.name;
      this.volatilityList.push(model.volatility[0]);
    }
    if (model && model.drawdown && model.drawdown.length) {
      model.drawdown[0].index = model.name;
      this.drawdownList.push(model.drawdown[0]);
    }
    if (model && model.sharpe && model.sharpe.length) {
      model.sharpe[0].index = model.name;
      this.sharpeList.push(model.sharpe[0]);
    }
  }

  ngOnInit(): void {
  }

}
